import React from 'react';
import { Container, MainContent } from './styles';
import MainTitle from 'components/MainTitle';
import BusinessList from './components/BusinessList';
import SelectMainNews from './components/SelectMainNews';

const NewsAdmin = (): JSX.Element => {
  return (
    <Container>
      <MainTitle>Gestão de Notícias</MainTitle>
      <MainContent>
        <SelectMainNews />
        <BusinessList />
      </MainContent>
    </Container>
  );
};

export default NewsAdmin;
